/** @jsx jsx */
import { jsx } from "theme-ui"
import React from "react"

const SocialLinks = () => (
  <>
    <a
      href="https://www.artstation.com/chuhe-wang/albums/all"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Artstation"
    >
      <span className="tooltipText" sx={{ display: `none` }}>
        Artstation
      </span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        height="1.7em"
        width="1.7em"
        viewBox="0 -10 200 200"
        xmlSpace="preserve"
      >
        <g>
          <path
            className="st0"
            d="M51.4,123.3l8.9,15.4l0,0c1.8,3.5,5.4,5.9,9.5,5.9l0,0l0,0h59.3l-12.3-21.3H51.4z"
          />
          <path
            className="st0"
            d="M157.2,123.4c0-2.1-0.6-4.1-1.7-5.8l-34.8-60.4c-1.8-3.4-5.3-5.7-9.4-5.7H92.9l53.7,93l8.5-14.7   C156.7,127,157.2,125.8,157.2,123.4z"
          />
          <polygon
            className="st0"
            points="108.1,108.1 84.2,66.6 60.2,108.1  "
          />
        </g>
      </svg>
    </a>
    <a
      href="https://www.linkedin.com/in/chuhe-wang-95ab09186/"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Linkedin"
    >
      <span className="tooltipText" sx={{ display: `none` }}>
        LinkedIn
      </span>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="30 0 400 450"
      >
        <path
          d="M150.65,100.682c0,27.992-22.508,50.683-50.273,50.683c-27.765,0-50.273-22.691-50.273-50.683
        C50.104,72.691,72.612,50,100.377,50C128.143,50,150.65,72.691,150.65,100.682z M143.294,187.333H58.277V462h85.017V187.333z
        M279.195,187.333h-81.541V462h81.541c0,0,0-101.877,0-144.181c0-38.624,17.779-61.615,51.807-61.615
        c31.268,0,46.289,22.071,46.289,61.615c0,39.545,0,144.181,0,144.181h84.605c0,0,0-100.344,0-173.915
        s-41.689-109.131-99.934-109.131s-82.768,45.369-82.768,45.369V187.333z"
        />
      </svg>
    </a>
  </>
)

export default SocialLinks
